import styled, { css } from 'styled-components/macro';

export const Wrapper = styled.div<{ $contained?: boolean }>`
  position: relative;
  width: 100%;
  overflow: hidden;

  ${({ $contained }) =>
    $contained
      ? css`
          margin: 0;
          padding: 0;
          min-width: 0;
          width: 100%;
          box-sizing: border-box !important;

          & > div:first-child {
            width: 100%;
            min-width: 0;
            max-width: 100%;
          }

          & * {
            box-sizing: border-box !important;
          }
        `
      : css`
          padding: 10px;
          margin: -10px;
          box-sizing: content-box !important;

          & * {
            box-sizing: border-box !important;
          }
        `}
`;
